<script setup>
import { ref, toRefs, computed } from 'vue'
import apiUser from '../../api/user.api'
import { debounce } from 'quasar';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

const props = defineProps({
  label: { type: String, default: '' }
})

const { label: labelProp } = toRefs(props)
const label = computed(() => labelProp.value || t('base.operator'))

const users = ref([])
const userOptions = ref([])
const page = ref(null)
const lastPage = ref(false)
const loading = ref(false)

async function getUserList (params) {
  loading.value = true
  const { data: { data: { users: _users, page: _page, lastPage: _lastPage } } } = await apiUser.getList(params)

  userOptions.value = Object.freeze(_users)
  page.value = _page
  lastPage.value = _lastPage
  loading.value = false
}

const filter = debounce((value) => {
  if (!value.length) {
    getUserList()
  }
  if (value.length >= 4) {
    getUserList({
      query: value
    })
  }
}, 500)

function paginate (prev) {
  getUserList({
    page: prev
      ? parseInt(page.value) - 1
      : parseInt(page.value) + 1
  })
}

getUserList()
</script>

<template lang='pug'>
.base-filter-user
  q-select.q-ml-xs(
    @update:model-value='value => $emit("data", value)'
    @input-value='filter'
    style='min-width: 200px'
    stack-label
    outlined
    dense
    :loading='loading'
    v-model='users'
    :options='userOptions'
    :label='label'
    multiple
    hide-dropdown-icon
    option-label='name'
    option-value='_id'
    :transition-duration='0'
    no-error-icon
    options-dense
    use-input
    hide-hint
    :popup-content-style=`{ 'width': 'auto' }`
  )
    template(v-slot:no-option='scope')
      .q-pa-sm {{ t('base.no_data') }}
    template(v-slot:option='{ itemProps, opt, selected, toggleOption }')
      q-item(v-bind='itemProps' style='padding: 0 5px')
        q-item-section(side)
          q-checkbox(
            :model-value='selected'
            @update:model-value='toggleOption(opt)'
          )
        q-item-section
          q-item-label.text-bold.q-pr-sm {{ opt.name }}
    template(v-slot:selected)
      .text-bold.q-mr-xs.rounded-borders.q-px-xs(
        :class=`$q.dark.isActive ? 'bg-grey-8' : 'bg-grey-5'`
        v-if='users.length'
        v-for='(item, index) in users.slice(0, 1)'
        :key='index'
      ) {{ item.name.length > 10 ? `${item.name.slice(0, 7)}...` : item.name }}
      .text-bold.rounded-borders.q-px-xs.cursor-pointer(
        :class=`$q.dark.isActive ? 'bg-grey-8' : 'bg-grey-5'`
        v-if='users.length > 1'
      ) +{{ users.length - 1 }}
        q-tooltip()
          div(
            v-for='(item, index) in users.slice(1, users.length)'
            :key='index'
          ) {{ item.name }}
    template(v-slot:after-options)
      .row.justify-center
        .col
          q-btn.full-width(
            color='primary'
            :class=`$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-4'`
            unelevated
            flat
            icon='chevron_left'
            :disable='page == 1'
            @click=`paginate(true)`
          )
        .col
          q-btn.full-width(
            color='primary'
            :class=`$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-4'`
            unelevated
            flat
            icon='chevron_right'
            :disable='lastPage'
            @click=`paginate(false)`
          )
</template>